var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJourneyLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 389 101"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F1EAFC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M4 47.857c24.724 12.311 86.989 29.548 138.256 0 64.084-36.936 94.346 5.642 117.488 22.571s45.682 39.963 56.658-5.652c7.324-30.432-4.259-53.18-27.624-53.18-17.076 0-39.175 43.648 44.199 80.271C374.718 110.203 414.541 65.687 351.5 4",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgJourneyLine;